<template>
  <NuxtLayout name="colored">
    <UiNarrowContainer>
      <div class="flex flex-col gap-6 rounded-xl bg-white p-8 text-center md:m-auto md:size-1/3 md:px-4">
        <UiHeading type="d1" class="!font-medium !text-primary-400">
          {{ statusCode }}
        </UiHeading>
        <div class="flex flex-col gap-4">
          <UiHeading type="h1">
            {{ errorTitle }}
          </UiHeading>
          <UiText>
            {{ errorDescription }}
          </UiText>
        </div>
      </div>
    </UiNarrowContainer>
  </NuxtLayout>
</template>

<script setup lang="ts">
import * as Sentry from '@sentry/nuxt';

const error = useError();
const { t } = useI18n();

if (error.value) {
  Sentry.captureException(error.value, {
    tags: { statusCode: error.value.statusCode as number },
  });
}

const statusCode = computed(() => (error.value?.statusCode === 500 ? 500 : 404));

const errorTitle = computed(() => t(`error.${statusCode.value}.title`));

const errorDescription = computed(() => t(`error.${statusCode.value}.description`));

useHead({
  title: errorTitle.value,
});
</script>
